import { z } from 'zod';

export const toFormikValidate = <T>(schema: z.ZodSchema<T>) => {
    return (values: T) => {
        try {
            schema.parse(values);
            return {};
        } catch (error) {
            if (error instanceof z.ZodError) {
                return error.errors.reduce(
                    (acc, curr) => {
                        const key = curr.path.join('.');
                        acc[key] = curr.message;
                        return acc;
                    },
                    {} as Record<string, string>,
                );
            }
            return {};
        }
    };
};
